import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

class SwitchBordCard2 extends React.Component {
  render() {
    const {
      Buttons,
      Buttons2,
      heading
    } = this.props;
    return (
      <div className="col-lg-12 col-md-12 col-sm-24">
        <div className="card">
          <div className="header">
            <h2>{heading}</h2>
            <div className="body">
              <table className="col-lg-12 col-md-12 col-sm-24">
                <tr>
                  <td className="col-lg-6 col-md-6 col-sm-12">
              <ul className="list-unstyled basic-list ng-star-inserted">
                {!Buttons &&
                  <li><b>No data</b></li>
                }
                {Buttons && Buttons.map((Button, index) => {
                  return (
                    <li
                      key={index}
                      className={
                        Button.switch===true
                          ? "ng-star-inserted text-danger"
                          : "ng-star-inserted"
                      }
                    >
                      {Button.title}
                      <span
                        style={{width: "80px"}}
                        className={
                          Button.switch===true
                          ? "ng-star-inserted text-dark badge"
                          : "ng-star-inserted text-danger badge"
                        }
                      >
                        {Button.title == 'BRAKE STATUS'?(Button.switch ? "Active":"In-Active"):(Button.switch ? "Open":"Close")}
                      </span>
                    </li>
                  );
                })}
              </ul>
              </td>
              <td className="col-lg-6 col-md-6 col-sm-12" style={{textAlign:"center",fontSize:"24pt"}}>
              <ul className="list-unstyled basic-list ng-star-inserted">
                {!Buttons2 &&
                  <li><b>No data</b></li>
                }
                {Buttons2 && Buttons2.map((Button, index) => {
                  return (
                    <li
                      key={index}
                      className="ng-star-inserted text-dark"         
                      style={{ display: "flex", flexDirection: "center", marginBottom: "20px"  }}             
                    >
                       <span style={{ width: "300px",marginRight: "20px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      {Button.title}
                      </span>
                      <div
                        style={{width: "200px",border:"none",fontSize:Button.title == 'Current Floor'?"92pt":"24pt",
                        display: "flex", alignItems: "center", justifyContent: "center", height: "100px",
                      }}
                        className={
                          Button.title == 'Car Door Status'? (Button.switch==false? "text-success badge":"text-danger badge") : "text-primary badge"
                        }
                      >
                        {Button.title == 'Current Floor'?(Button.data==-1?"NA":Button.data):(Button.switch ? "Open":"Close")}
                      </div>
                    </li>
                  );
                })}
              </ul>
              </td>
              </tr></table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SwitchBordCard2.propTypes = {};

export default (SwitchBordCard2);
